import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/styles';
import {
  FormControl,
  Box,
  OutlinedInput,
  InputLabel,
  MenuItem,
  Select,
  Chip,
  FormHelperText,
} from '@material-ui/core';
import { Cancel } from '@material-ui/icons';

function getStyles(value, items, theme) {
  return {
    fontWeigth: items.indexOf(value) === -1
      ? theme.typography.fontWeightRegular
      : theme.typography.fontWeightMedium,
  };
}

const MultipleSelect = ({
  items = [],
  label = '',
  field: {
    name,
    value: valueField,
  },
  form: {
    touched, errors, setFieldValue, setFieldTouched,
  },
  ...rest
}) => {
  const theme = useTheme();
  const [selected, setSelected] = useState(valueField || []);

  const handleChange = ({ target: { value } }) => {
    setSelected(value);
    setFieldValue(name, value);
    setFieldTouched(name, true);
  };

  const handleDelete = (e, i) => {
    e.preventDefault();
    setSelected((prev) => prev.filter((item) => item !== prev[i]));
    setFieldValue(name, selected.filter((item) => item !== selected[i]));
    setFieldTouched(name, true);
  };

  const hasError = touched[name] && Boolean(errors[name]);

  return (
    <FormControl variant="outlined" fullWidth margin="dense" error={hasError}>
      <InputLabel id="demo-multiple-chip-label">{label}</InputLabel>
      <Select
        id="demo-multiple-chip"
        multiple
        value={selected}
        onChange={handleChange}
        input={<OutlinedInput id="select-multiple-chip" label={label} />}
        {...rest}
        renderValue={(s) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {s.map((value, i) => (
              <Chip
                key={value}
                label={value}
                disabled={rest.disabled}
                deleteIcon={
                  (
                    <Cancel
                      disabled={rest.disabled}
                      onMouseDown={(event) => event.stopPropagation()}
                    />
                  )
                }
                onDelete={(e) => handleDelete(e, i)}
              />
            ))}
          </Box>
        )}
      >
        {items.map((item) => (
          <MenuItem
            key={item}
            value={item}
            style={getStyles(item, selected, theme)}
          >
            {item}
          </MenuItem>
        ))}
      </Select>
      {hasError && <FormHelperText>{errors[name]}</FormHelperText>}
    </FormControl>
  );
};

MultipleSelect.propTypes = {
  items: PropTypes.oneOfType([PropTypes.array]),
  label: PropTypes.string,
  field: PropTypes.shape(),
  form: PropTypes.shape(),
};

export default MultipleSelect;
